import React from 'react';
import {NavLink, Outlet} from 'react-router-dom';
import './SettingsLayout.css';

/**
 * Settings Layout Component with submenu navigation
 * Provides a consistent layout for all settings pages
 */
const SettingsLayout = () => {
  return (
    <div className="settings-container">
      <div className="settings-header">
        <div className="settings-header-content">
          <h1 className="settings-title">{'Settings'}</h1>
        </div>
      </div>

      {/* Submenu Navigation */}
      <nav className="settings-nav">
        <NavLink 
          className={({isActive}) => `settings-nav-item ${isActive ? 'active' : ''}`}
          end
          to="/settings"
        >
          {'User Profile'}
        </NavLink>
        <NavLink 
          className={({isActive}) => `settings-nav-item ${isActive ? 'active' : ''}`}
          to="/settings/theme"
        >
          {'Theme'}
        </NavLink>
        <NavLink 
          className={({isActive}) => `settings-nav-item ${isActive ? 'active' : ''}`}
          to="/settings/advanced"
        >
          {'Advanced'}
        </NavLink>
        <NavLink 
          className={({isActive}) => `settings-nav-item ${isActive ? 'active' : ''}`}
          to="/settings/analytics"
        >
          {'Analytics'}
        </NavLink>
        <NavLink 
          className={({isActive}) => `settings-nav-item ${isActive ? 'active' : ''}`}
          to="/settings/privacy"
        >
          {'Privacy'}
        </NavLink>
        <NavLink
          className={({isActive}) => `settings-nav-item ${isActive ? 'active' : ''}`}
          to="/settings/billing"
        >
          {'Billing & Usage'}
        </NavLink>
      </nav>

      {/* Content Area */}
      <div className="settings-outlet">
        <Outlet />
      </div>
    </div>
  );
};

export default SettingsLayout;
